export default __webpack_public_path__ + "static/media/photo11.a0cd5c8c.jpg";